export default "__VITE_ASSET__057d7591__"